import React from "react";
import { Link } from "react-router-dom";
import { CHECK_ICON } from "../../lib/assets";
import { SERVICES } from "../../content/siteContent";

export const PecHomeSection = () => {
  const pecService =
    SERVICES.find((service) => service.slug === "pec-services") || SERVICES[0];

  return (
    <section className="home-secp-section home-pec-section">
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-lg-6 order-0 order-lg-2">
            <div className="home-secp-content">
              <div className="section-title mb-30 tg-heading-subheading animation-style2">
                <span className="sub-title tg-element-title">PEC Services</span>
                <h2 className="title tg-element-title">
                  End-to-end PEC registration support for engineering professionals and firms
                </h2>
              </div>
              <p>{pecService.intro}</p>

              <div className="home-secp-points">
                <ul className="list-wrap">
                  {pecService.overviewItems.slice(0, 3).map(([title, text]) => (
                    <li key={title}>
                      <img src={CHECK_ICON} alt="" />
                      <div>
                        <h5>{title}</h5>
                        <p>{text}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="home-secp-actions">
                <Link to={`/services/${pecService.slug}`} className="btn">
                  Explore PEC Service
                </Link>
                <Link to="/contact" className="btn transparent-btn">
                  Talk to Our Team
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6 order-0 order-lg-1">
            <div className="home-secp-grid">
              <div className="home-secp-feature-card home-secp-feature-card-primary">
                <span className="label">Core Service</span>
                <h3>{pecService.shortTitle}</h3>
                <p>{pecService.cardText}</p>
              </div>

              <div className="home-secp-feature-card">
                <span className="label">Coverage</span>
                <h4>Registration, renewal, and upgradation</h4>
                <p>
                  Support for contractor categories, consultant firms, foreign
                  engineering companies, and specialized PEC codes.
                </p>
              </div>

              <div className="home-secp-feature-card">
                <span className="label">Application Support</span>
                <h4>Structured documentation and workflow handling</h4>
                <p>
                  We prepare files, review eligibility, submit applications,
                  and follow up through to registration approval.
                </p>
              </div>

              <div className="home-secp-feature-card">
                <span className="label">Why Businesses Choose Zawix</span>
                <ul className="list-wrap">
                  {pecService.highlights.slice(0, 3).map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
